import * as app from './request';
import * as captcha from '../index';

interface SMSProps extends SMSOptions {
  app_id: number;
}

export default class SMS {
  props: SMSProps;
  verifyOptions: VerifyOptions;
  constructor(options: VerifyOptions) {
    const finalVerifyOptions = { ...window.verifyOptions, ...options };
    const { commonOptions, smsOptions } = finalVerifyOptions;
    this.verifyOptions = finalVerifyOptions;
    this.props = {
      app_id: commonOptions.aid,
      channel_id: smsOptions.channel_id,
      scene: smsOptions.scene,
      code_type: smsOptions.code_type,
      language: smsOptions.language,
      event_type: smsOptions.event_type,
      uid: smsOptions.uid,
      template_id: smsOptions.template_id,
    };
    if (smsOptions.host) {
      app.request.defaults.baseURL = smsOptions.host;
    }
  }
  async sendCode({ mobile }: { mobile: string }, options?: SMSOptions) {
    const verifyOptions = this.verifyOptions;
    const {
      app_id,
      channel_id,
      scene,
      code_type,
      language,
      event_type,
      uid,
      template_id,
    } = Object.assign(this.props, options);
    try {
      const fp = await captcha.getCaptchaWebId();
      const res = await app.sendCode(
        {
          mobile,
          app_id,
          channel_id,
          scene,
          code_type,
          language,
          event_type,
          uid,
          template_id,
          // passport 那边从请求体里取 fp 作为 fp
          verifyFp: fp,
          fp,
        },
        {
          // 验证中心这边从查询参数里取 verifyFp 作为 fp
          verifyFp: fp,
          fp,
        }
      );
      const { data: resData } = res;
      if (resData.decision === 'PASS') {
        return res;
      } else {
        return new Promise((resolve, reject) => {
          const retry = async () => {
            try {
              const res2 = await this.sendCode(
                {
                  mobile,
                },
                options
              );
              resolve(res2);
            } catch (error) {
              reject(error);
            }
          };
          captcha.autoRender({
            verify_data: resData.decision,
            commonOptions: verifyOptions.commonOptions,
            captchaOptions: {
              ...verifyOptions.captchaOptions,
              autoClose: true,
              successCb: async () => {
                retry();
              },
              closeCb: () => {
                reject(res);
              },
            },
            secondVerifyWebOptions: {
              ...verifyOptions.secondVerifyWebOptions,
              callBack: () => {
                retry();
              },
              closeCallBack: () => {
                reject(res);
              },
            },
          });
        });
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async validateCode(
    { mobile, code }: { mobile: string; code: string },
    options?: Partial<SMSOptions>
  ) {
    const { app_id, scene } = Object.assign(this.props, options);
    return app.validateCode({
      mobile,
      app_id,
      scene,
      code,
    });
  }
}
